import { render, staticRenderFns } from "./ChatX3.vue?vue&type=template&id=238a760a&"
import script from "./ChatX3.vue?vue&type=script&lang=js&"
export * from "./ChatX3.vue?vue&type=script&lang=js&"
import style0 from "./ChatX3.vue?vue&type=style&index=0&id=238a760a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports